export class AuthorizerException extends Error {
  constructor() {
    super();
    this.name = 'AuthorizerException';
  }
}
